import { ApiException } from '@eta/components';
import { createAction } from 'redux-actions';
import { TaxpayerProfileService } from '../../Services/TaxpayerProfile/Service';
import {
    LOAD_TAXPAYER_PROFILE,
    UPDATE_TAXPAYER_PROFILE,
    LOAD_TAXPAYER_NOTIFICATIONS,
    UPDATE_TAXPAYER_NOTIFICATIONS,
    INVITE_USER,
    ADDERP_SYSTEM,
    EDIT_ERPSYSTEM,
    BLOCK_USER,
} from './Types';
import {
    UpdateCompanyProfileRequest,
    RegisterDelegateDto,
    UpdateSystemDelegateRequest,
    DelegetesStatusUpdateDto,
} from '../../Services/ClientProxy/clientProxy';
import { RecipientPreferenceRequestDto } from '../../Services/ClientProxy/NotificationManagementClient';

const taxpayerProfileService = new TaxpayerProfileService();
// TypeScript infers that this function is returning SendMessageAction

export const loadTaxpayerProfile = createAction(
    LOAD_TAXPAYER_PROFILE,
    async () => {
        try {
            return await taxpayerProfileService.getTaxpayerProfile();
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException };
        }
    }
);

export const loadTaxpayerNotifications = createAction(
    LOAD_TAXPAYER_NOTIFICATIONS,
    async () => {
        try {
            return await taxpayerProfileService.getTaxpayerNotification();
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException };
        }
    }
);

export const updateTaxpayerProfile = createAction(
    UPDATE_TAXPAYER_PROFILE,
    async (profile: UpdateCompanyProfileRequest) => {
        try {
            await taxpayerProfileService.updateTaxpayerProfile(profile);
        } catch (serviceError) {
            return { lastError: serviceError, profile };
        }
        return { lastError: null, profile };
    }
);

export const updateTaxpayerNotifications = createAction(
    UPDATE_TAXPAYER_NOTIFICATIONS,
    async (request: RecipientPreferenceRequestDto) => {
        try {
            await taxpayerProfileService.updateTaxpayerNotification(request);
        } catch (serviceError) {
           
            return { lastError: serviceError, request };
        }
        return { lastError: null, request };
    }
);

export const inviteUser = createAction(
    INVITE_USER,
    async (request: RegisterDelegateDto) => {
        try {
            await taxpayerProfileService.inviteUser(request);
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException, request };
        }
        return { lastError: null, request };
    }
);

export const addErpSystem = createAction(
    ADDERP_SYSTEM,
    async (request: RegisterDelegateDto) => {
        let response;
        try {
          response = await taxpayerProfileService.addErpSys(request);
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException, response };
        }
        return { lastError: null, response };
    }
);

export const editErpSystem = createAction(
    EDIT_ERPSYSTEM,
    async (request: UpdateSystemDelegateRequest) => {
        let response;
        try {
            response = await taxpayerProfileService.editErpSystem(request);
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException, response};
        }
        return { lastError: null, response };
    }
);

export const changeUserStatus = createAction(
    BLOCK_USER,
    async (request: DelegetesStatusUpdateDto) => {
        let response;
        try {
            response = await taxpayerProfileService.changeUserStatus(request);
            
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException, response};
        }
        return { lastError: null, response };
    }
);
